module.exports = __webpack_public_path__ + "img/3.0a594a86.png";